import ComplaintForm from './ComplaintForm';

export default ComplaintForm;
